var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2022 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
// This no check will need to be removed at some point
// It is in to prevent build errors to do with the Dropdown type
// not containing detail and element props
// @ts-nocheck
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { Navigation, Callback, PageNotFound } from "./nav";
import { getTokenFromLocalStorage, getUserFromLocalStorage } from './services/localStorage/localStorageService';
import { confirmAuthorised } from './services/auth/authService';
import { AuthProvider } from './contexts/auth.context';
import Footer from './general/Footer';
import { convertToPath, matomoAnalytics } from "./general/Utils";
import { env } from './variables/config';
function TolApp(props) {
    var _a = useState(getTokenFromLocalStorage), token = _a[0], setToken = _a[1];
    var _b = useState(getUserFromLocalStorage), user = _b[0], setUser = _b[1];
    useEffect(function () {
        var siteId = env.MATOMO_SITE_ID;
        matomoAnalytics(siteId);
    }, []);
    // show login button as default
    var login = props.login;
    if (login === undefined) {
        login = true;
    }
    if (!("API_PATH" in env)) {
        return (_jsx("div", { children: _jsx("h3", { children: "Please add 'API_PATH' as an environment variable (e.g. API_PATH=/api/v1)." }) }));
    }
    return (_jsx("div", __assign({ id: "tol-app-background" }, { children: _jsx(AuthProvider, __assign({ value: {
                token: token,
                setToken: setToken,
                user: user,
                setUser: setUser,
            } }, { children: _jsxs(Router, { children: [_jsx(Navigation, { brand: props.brand, pages: props.pages, login: login }), _jsx("div", __assign({ className: "tol-app" }, { children: _jsxs(Switch, { children: [_jsx(Route, { path: "/", exact: true, component: function () { return props.homePage; } }), _jsx(Route, __assign({ path: "/callback", exact: true }, { children: _jsx(Callback, {}) })), props.pages.map(function (page) {
                                    var path = convertToPath(page.name);
                                    var routes = [];
                                    var authorised = confirmAuthorised(user, page.auth);
                                    // dropdown routes
                                    if (page.pages) {
                                        page.pages.forEach(function (dropdownPage) {
                                            var dropdownPath = convertToPath(page.name) + convertToPath(dropdownPage.name);
                                            // dropdown page route
                                            routes.push(_jsx(Route, __assign({ exact: true, path: dropdownPath }, { children: authorised ? dropdownPage.element : _jsx(Redirect, { to: "/" }) }), dropdownPath));
                                            // dropdown detail page route
                                            if (dropdownPage.detail) {
                                                routes.push(_jsx(Route, __assign({ exact: true, path: "".concat(dropdownPath, "/:id") }, { children: authorised ? dropdownPage.detail : _jsx(Redirect, { to: "/" }) }), "".concat(dropdownPath, "-detail")));
                                            }
                                        });
                                    }
                                    else {
                                        // regular page route
                                        routes.push(_jsx(Route, __assign({ exact: true, path: path }, { children: authorised ? page.element : _jsx(Redirect, { to: "/" }) }), page.name));
                                        // detail page route
                                        if (page.detail) {
                                            routes.push(_jsx(Route, __assign({ exact: true, path: "".concat(path, "/:id") }, { children: authorised ? page.detail : _jsx(Redirect, { to: "/" }) }), "".concat(page.name, "-detail")));
                                        }
                                    }
                                    return routes;
                                }), _jsx(Route, { path: "/page-not-found", component: function () { return _jsx(PageNotFound, {}); } }), _jsx(Route, __assign({ path: "*" }, { children: _jsx(Redirect, { to: "/page-not-found" }) }))] }) })), _jsx(Footer, {})] }) })) })));
}
export default TolApp;
